import { createSlice } from '@reduxjs/toolkit';
/* eslint-disable no-param-reassign */
// CONSIDERATION for reducers:
// Redux Toolkit allows us to write "mutating" logic in reducers. It
// doesn't actually mutate the state because it uses the Immer library,
// which detects changes to a "draft state" and produces a brand new
// immutable state based off those changes
export const selectedContactPageSlice = createSlice({
    name: 'selectedContactPage',
    initialState: null,
    reducers: {
        setSelectedContactId: (state, { payload }) => payload.contactId,
    },
});

// Action creators are generated for each case reducer function
export const { setSelectedContactId } = selectedContactPageSlice.actions;

export default selectedContactPageSlice.reducer;
